export enum SearchCategoriesEnum {
  DANCE_STUDIOS = 'dance-studios',
  DANCE_CLASSES = 'dance-classes',
  DANCE_EVENTS = 'dance-events',
  DANCE_PARTNERS = 'dance-partners',
  COURSE = 'courses',
}
